<script setup lang='ts'>
import { CalendarDays } from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import TheDurationFilter from '@/components/mode-list-filters/TheDurationFilter.vue';
import TheMultiselectFilter from '@/components/mode-list-filters/TheMultiselectFilter.vue';
import ThePriceFilter from '@/components/mode-list-filters/ThePriceFilter.vue';
import TheTimeRangeFilter from '@/components/mode-list-filters/TheTimeRangeFilter.vue';
import TheCalendar from '@/components/mode-list/TheCalendar.vue';
import { useFiltersStore } from '@/stores/useFiltersStore';
import { useMetricsStore } from '@/stores/useMetricsStore';

const { t } = useI18n();

const metricsStore = useMetricsStore();
const { places } = storeToRefs(metricsStore);

const filtersStore = useFiltersStore();

const timeRangeOptions = [
  { label: t('timeRange.morning'), minTime: 480, maxTime: 720, count: 0 },
  { label: t('timeRange.afternoon'), minTime: 720, maxTime: 1020, count: 0 },
  { label: t('timeRange.evening'), minTime: 1020, maxTime: 1440, count: 0 },
];
</script>

<template>
  <h3 class="dates-title">
    <span><CalendarDays :size="22" color="var(--yb-color-black)" aria-hidden="true" /></span>{{ t('search.dates') }}
  </h3>
  <TheCalendar :columns="1" :rows="2" />
  <div class="price-filter">
    <h3>{{ t('menu.price') }}</h3>
    <div>
      <ThePriceFilter :placeholder="t('menu.duration')" :min="0" :max="1500" :step="10" :average="79" />
    </div>
  </div>
  <hr>
  <div>
    <h3>{{ t('menu.duration') }}</h3>
    <TheDurationFilter :min="0" :max="24" :step="1" />
  </div>
  <hr>
  <div>
    <h3>{{ t('menu.moment') }}</h3>
    <TheTimeRangeFilter :options="timeRangeOptions" />
  </div>
  <hr>
  <div v-if="places.length">
    <h3>{{ t('menu.place') }}</h3>
    <TheMultiselectFilter :options="places" @update:model-value="filtersStore.addPlacesFilters" />
  </div>
</template>

<style lang="css" scoped>
.dates-title {
  display: flex;
  align-items: center;
  margin-bottom: var(--yb-spacing-sm);
  margin-top: var(--yb-spacing-base);

  span {
    margin-right: var(--yb-spacing-sm);
  }
}

.price-filter {
  margin-top: var(--yb-spacing-base);
}

h3 {
  margin-bottom: var(--yb-spacing-sm);
}

hr {
  margin-block: var(--yb-spacing-base);
  border: 1px solid var(--yb-color-lightgray);
}
</style>
